import React from 'react'
import {
    UiContentWr,
    UiContentCol

} from "../../../components/common/UiPageElements";
import { UiInput } from '../../../components/form/UiInput';
import { UiButtonPrimary } from '../../../components/form/UiButton';

export default function RealTimeCodeEntry(props) {
    
    return (
        <>
            <div className='sb-real-time-code-entry'>
                <h3>Realtime Code Entry</h3>
                <p>Got a realtime code? Add it to you score total by entering it here:</p>
                <UiInput placeholder="Insert code"/>
                <UiButtonPrimary btnName="Submit"/>
            </div>
            
        </>
    )
}
